import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { judgeQuoteIsCombineR2RScheme, judgeQuoteIsR2RScheme, judgeQuoteIsUCESScheme } from '../../flagJudgement/quote';
export var useQuotePromotionInfo = function useQuotePromotionInfo() {
  var _ref = useFormContext() || {},
      watch = _ref.watch;

  var _useState = useState(false),
      quoteIsR2RScheme = _useState[0],
      setQuoteIsR2RScheme = _useState[1];

  var _useState2 = useState(false),
      quoteIsCombineR2RScheme = _useState2[0],
      setQuoteIsCombineR2RScheme = _useState2[1];

  var _useState3 = useState(false),
      quoteIsUCESScheme = _useState3[0],
      setQuoteIsUCESScheme = _useState3[1];

  var promotionInfoWacth = watch === null || watch === void 0 ? void 0 : watch('promotionInfo');
  useEffect(function () {
    setQuoteIsR2RScheme(judgeQuoteIsR2RScheme({
      promotionInfo: _objectSpread(_objectSpread({}, promotionInfoWacth), {}, {
        payload: promotionInfoWacth === null || promotionInfoWacth === void 0 ? void 0 : promotionInfoWacth.promotionPayload
      })
    }));
    setQuoteIsCombineR2RScheme(judgeQuoteIsCombineR2RScheme({
      promotionInfo: _objectSpread(_objectSpread({}, promotionInfoWacth), {}, {
        payload: promotionInfoWacth === null || promotionInfoWacth === void 0 ? void 0 : promotionInfoWacth.promotionPayload
      })
    }));
    setQuoteIsUCESScheme(judgeQuoteIsUCESScheme({
      promotionInfo: _objectSpread(_objectSpread({}, promotionInfoWacth), {}, {
        payload: promotionInfoWacth === null || promotionInfoWacth === void 0 ? void 0 : promotionInfoWacth.promotionPayload
      })
    }));
  }, [promotionInfoWacth]);
  return {
    quoteIsR2RScheme: quoteIsR2RScheme,
    quoteIsCombineR2RScheme: quoteIsCombineR2RScheme,
    quoteIsUCESScheme: quoteIsUCESScheme
  };
};